module.exports = __webpack_public_path__ + "static/media/IMG_8374-min.bce5dd91.jpg";